
import { Component, Prop, Vue, Watch } from 'vue-facing-decorator'

@Component({

})
export default class extends Vue {

  @Prop()
  modelValue: any;

  @Watch('modelValue.category', {
    deep: true
  })
  @Watch('modelValue.goodsType')
  @Watch('modelValue.goodsIds')
  refreshWatch() {
    this.goods = [];
    this.getList();
  }


  goods = []

  get list() {
    if (this.modelValue.goodsType == "goods") {
      if (this.goods && this.goods.length) {
        return this.goods;
      }
    } else if (this.modelValue.goodsType == "category") {
      if (this.goods && this.goods.length) {
        return this.goods;
      }
    }
    return Array.apply(null, { length: this.count }).map((item, index) => {
      return this.getDefault(index);
    });
  }
  /**
   * 小图的商品宽度 = 一行几个由 rowCount 决定（不填按 2）。
   * 间距和列表模式的 margin-bottom 仍在 CSS 里，这里只给宽度。
   * 用 5px 而不是取「图片间距」：商品组件没有那个设置项，CSS 里写死的就是 5px。
   */
  get rowCountStyle() {
    if (this.modelValue.listMode != "small") return "";
    let percent = 100 / (Number(this.modelValue.rowCount) || 2);
    return { width: `calc(${percent}% - 5px)` };
  }

  /**
   * 标签没配色就走店铺主题的主色/辅色（同分组）。
   * 不带 borderTopLeftRadius —— 商品组件没有「图片边角」那个设置项。
   */
  get tagStyle() {
    return {
      backgroundColor: this.modelValue.tagBgColor || "var(--primary-color)",
      color: this.modelValue.tagTextColor || "var(--secondary-color)",
    };
  }

  get count() {
    switch (this.modelValue.listMode) {
      case "minix":
        return 5;
      case "big":
      case "list":
        return 3;
    }
    // 小图：占位卡铺满两行，看得出一行几个
    return (Number(this.modelValue.rowCount) || 2) * 2;
  }

  created() {
    this.getList();
  }

  async getList() {
    if (this.modelValue.goodsType == "goods") {
      this.getGoodsList();
    } else {
      this.getGoodsCategory();
    }
  }

  async getGoodsList() {
    if (this.modelValue.goodsIds && this.modelValue.goodsIds.length) {
      let { error, data } = await this.$post("/manager/goods/list", {
        ids: this.modelValue.goodsIds,
        pageSize: -1,
      });
      if (error) return;
      this.goods = data.list;
      return;
    }
    this.goods = [];
  }
  async getGoodsCategory() {
    if (this.modelValue.category) {
      let { error, data } = await this.$post("/manager/goods/list", {
        pageSize: this.modelValue.category.count,
        categoryId: [this.modelValue.category.id],
      });
      if (error) return;
      this.goods = data.list;
      return;
    }
    this.goods = [];
  }
  getDefault(index) {
    switch (this.modelValue.listMode) {
      case "big":
        return {
          name: "这里显示商品名字，最多显示一行",
          cover: require("./images/default.png"),
          showPrice: 99,
        };
      case "minix":
        if (index == 0) {
          return {
            name: "这里显示商品名字，最多显示一行",
            cover: require("./images/default.png"),
            showPrice: 99,
          };
        }
    }
    return {
      name: "这里显示商品名字，最多显示二行",
      cover: require("./images/default.png"),
      showPrice: 99,
    };
  }
}
